export { default } from './FormPageDictionary.vue'
